var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b7a4df04086e3bc4e264aa7aed04585f.js').default;export default
        Object.assign({}, scope_0 )
    